/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import type { Token } from "@/domains/core"
import { routerAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type CreateLiquidityPoolProps = {
  account: Address
  chainId: number
  config: Config
  token0: Token
  token1: Token
  isStable: boolean
  amountADesired: bigint
  amountBDesired: bigint
  amountAMin: bigint
  amountBMin: bigint
  deadline: number
  routerAddress: Address
}

export const createLiquidityPool = async ({
  account,
  chainId,
  config,
  token0,
  token1,
  isStable,
  amountADesired,
  amountBDesired,
  amountAMin,
  amountBMin,
  deadline,
  routerAddress,
}: CreateLiquidityPoolProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: routerAbi as unknown as Abi,
        account,
        address: routerAddress,
        args: [
          token0.address,
          token1.address,
          isStable,
          amountADesired,
          amountBDesired,
          amountAMin,
          amountBMin,
          account,
          deadline,
        ],
        chainId,
        functionName: "addLiquidity",
      },
    })
    return result
  } catch (error: any) {
    console.error("createLiquidityPool", error)
    return { success: false, error: error.message, code: error.code }
  }
}
